/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {closeSecondaryModal, openSecondaryModal} from 'helpers/actions'
import EditCalculationDiscountModal from "components/Offers/EditCalculationDiscountModal";
import {ModalSize} from 'types/enums/ModalSize'
import React from "react";
import type {OfferCalculation} from "types/entities/OfferCalculation";
import type {PackagesCart} from "types/entities/PackagesCart";
import type {Offer} from "types/entities/Offer";
import {useTranslation} from "react-i18next";
import {useAppDispatch} from "helpers/store";
import UiAlertConfirmationModal from "components/Ui/UiAlertConfirmationModal";
import OffersAction from "store/offers/OffersAction";
import {toast} from "utils/toastUtils";

export const useVoucherUtilModals = () => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const onEditCalculationDiscountHandler = (
        calculation: OfferCalculation,
        packagesCart: PackagesCart,
        offer: Offer,
        voucher_id?: number
    ) => {
        dispatch(
            openSecondaryModal(
                <EditCalculationDiscountModal
                    calculation={calculation}
                    packagesCart={packagesCart}
                    offerId={offer.id}
                    sellerId={offer.seller_id}
					voucher_id={voucher_id}
                    closeModal={() => dispatch(closeSecondaryModal())}
                />,
                {
                    modalSize: ModalSize.Small,
                },
                t('Edit Discount')
            )
        )
    }

    const onDeleteCalculationDiscountHandler = (packagesCart: PackagesCart, offer: Offer, voucher_id: number) => {
        dispatch(
            openSecondaryModal(
                <UiAlertConfirmationModal
                    title={t('Remove Discount')}
                    message={t('Are you sure you want to remove this discount?')}
                    onConfirm={async () => {
                        try {
                            await dispatch(
                                OffersAction.fetchDeleteVoucherFromCalculation(
                                    packagesCart.id,
                                    offer.id,
                                    offer.seller_id,
                                    voucher_id
                                )
                            )
                            toast.success(t('Discount removed successfully'))
                            dispatch(closeSecondaryModal())
                        } catch (error) {
                            console.log(error)
                            toast.error(t('Failed to remove discount'))
                        }
                    }}
                    onCancel={() => dispatch(closeSecondaryModal())}
                />,
                { modalSize: ModalSize.Small },
                t('Confirm')
            )
        )
    }

    return {
        onEditCalculationDiscountHandler,
        onDeleteCalculationDiscountHandler,
    }
}
